import { render, staticRenderFns } from "./RecommendedEmployees.vue?vue&type=template&id=604fd401"
import script from "./RecommendedEmployees.vue?vue&type=script&lang=js"
export * from "./RecommendedEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports